// 🤖 AUTO-GENERATED from data/components.json
// DO NOT EDIT MANUALLY - Changes will be overwritten
// Schema version: 1.0.0

import type { VoltraBaseProps } from '../baseProps'

export type HStackProps = VoltraBaseProps & {
  /** Spacing between children */
  spacing?: number
  /** Vertical alignment */
  alignment?: 'top' | 'center' | 'bottom'
}
